(() => {
  if (window.rudcaCardAlignment) return;
  window.rudcaCardAlignment = true;
  const titleSelector = '.product-item__title, .rudca-cart-table .line-item__title, .mini-cart__product-title';
  const scopeSelector = '.rudca-cart-recommendations__list, .rudca-discovery__list, .rudca-origin-browser__grid, .product-list, .rudca-cart-table, .mini-cart__line-item-list';
  const states = new WeakMap();
  const priceStates = new WeakMap();
  const observed = new Set();
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(align);
  };
  const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver((entries) => {
    if (entries.some((entry) => {
      const state = states.get(entry.target);
      return !state || Math.abs(state.width - entry.contentRect.width) > 1;
    })) schedule();
  }) : null;
  function align() {
    queued = false;
    const groups = new Map();
    for (const title of document.querySelectorAll(titleSelector)) {
      const scope = title.closest(scopeSelector);
      if (!scope) continue;
      const bounds = title.getBoundingClientRect();
      if (bounds.width < 1 || !title.getClientRects().length) continue;
      const style = getComputedStyle(title);
      const fontSize = parseFloat(style.fontSize) || 14;
      const lineHeight = parseFloat(style.lineHeight) || fontSize * 1.35;
      const isCard = title.matches('.product-item__title');
      const minimum = lineHeight * (isCard ? 3 : 2);
      const range = document.createRange();
      range.selectNodeContents(title);
      const textBounds = range.getBoundingClientRect();
      const natural = Math.ceil(Math.max(0, textBounds.height - 0.5) / lineHeight) * lineHeight;
      const scopeWidth = scope.clientWidth;
      let state = states.get(scope);
      if (!state || Math.abs(state.width - scopeWidth) > 1) {
        state = { width: scopeWidth, heights: new Map() };
        states.set(scope, state);
      }
      if (resizeObserver && !observed.has(scope)) {
        observed.add(scope);
        resizeObserver.observe(scope);
      }
      const card = title.closest('.product-item');
      const layout = card?.classList.contains('product-item--horizontal') ? 'horizontal' : card?.classList.contains('product-item--list') ? 'list' : isCard ? 'vertical' : 'cart';
      const key = [layout, Math.round(bounds.width), lineHeight, style.fontSize, style.fontFamily].join('|');
      let byKey = groups.get(scope);
      if (!byKey) { byKey = new Map(); groups.set(scope, byKey); }
      let group = byKey.get(key);
      if (!group) {
        group = { titles: [], height: state.heights.get(key) || minimum, state };
        byKey.set(key, group);
      }
      group.titles.push(title);
      group.height = Math.max(group.height, minimum, natural);
    }
    for (const byKey of groups.values()) {
      for (const [key, group] of byKey) {
        const height = Math.ceil(group.height * 100) / 100;
        group.state.heights.set(key, height);
        for (const title of group.titles) {
          const value = `${height}px`;
          if (title.style.getPropertyValue('--rudca-aligned-title-height') !== value) title.style.setProperty('--rudca-aligned-title-height', value);
        }
      }
    }
    for (const scope of document.querySelectorAll('.rudca-cart-table, .mini-cart__line-item-list')) {
      if (!scope.getClientRects().length || scope.clientWidth < 1) continue;
      const scopeWidth = scope.clientWidth;
      let state = priceStates.get(scope);
      if (!state || Math.abs(state.width - scopeWidth) > 1) state = { width: scopeWidth, priceWidth: 0 };
      let width = state.priceWidth;
      for (const price of scope.querySelectorAll('.line-item__price-list > .line-item__price:not(.line-item__price--compare), .mini-cart__price-list > .price:not(.price--compare)')) {
        if (!price.getClientRects().length) continue;
        const range = document.createRange();
        range.selectNodeContents(price);
        width = Math.max(width, range.getBoundingClientRect().width);
      }
      if (width > 0) {
        state.priceWidth = Math.ceil(width * 100) / 100;
        priceStates.set(scope, state);
        const value = `${state.priceWidth}px`;
        if (scope.style.getPropertyValue('--rudca-cart-price-column') !== value) scope.style.setProperty('--rudca-cart-price-column', value);
      }
    }
    for (const scope of observed) {
      if (!scope.isConnected) { resizeObserver.unobserve(scope); observed.delete(scope); }
    }
  }
  function start() {
    schedule();
    new MutationObserver((records) => {
      if (records.some((record) => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target?.closest(scopeSelector)) return true;
        return Array.from(record.addedNodes).some((node) => node.nodeType === 1 && (node.matches(titleSelector) || node.querySelector(titleSelector)));
      })) schedule();
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    // New cart rows must receive their measured geometry before viewport restoration.
    document.addEventListener('cart:rerendered', align);
    document.fonts?.ready.then(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

